package net.bothosting.docs

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 * @property sidebarBackground Background color for the sidebar panel.
 * @property sidebarText Muted text color used for sidebar nav items.
 * @property selectedHighlight Background color for the active/selected sidebar item island.
 */
class SitePalette(
    val nearBackground: Color,
    val sidebarBackground: Color,
    val sidebarText: Color,
    val sidebarTextHover: Color,
    val selectedHighlight: Color,
    val sidebarIcon: Color,
    val sectionLabel: Color,
    val cardBorder: Color,
    val accent: Color,
    val islandBackground: Color,
    val islandAccent: Color,
)

object SitePalettes {
    val dark = SitePalette(
        nearBackground = Color.rgb(0x0a0e1a),
        sidebarBackground = Color.rgb(0x020304),
        sidebarText = Color.rgb(0x828a9b),
        sidebarTextHover = Color.rgb(0xe2e8f0),
        selectedHighlight = Color.rgb(0x132044),
        sidebarIcon = Color.rgb(0x5a6273),
        sectionLabel = Color.rgb(0x5a6273),
        cardBorder = Color.rgb(0x1e293b),
        accent = Color.rgb(0x008bf6),
        islandBackground = Color.rgb(0x040609),
        islandAccent = Color.rgb(0x080c0f),
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.DARK -> SitePalettes.dark
        ColorMode.LIGHT -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Color.rgb(0xFAFAFA)
    ctx.theme.palettes.light.color = Color.rgb(0x030712)
    ctx.theme.palettes.dark.background = Color.rgb(0x020408)
    ctx.theme.palettes.dark.color = Color.rgb(0xe2e8f0)
}

@InitSilk
fun initSilk(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("html, body") {
        base {
            Modifier.fontFamily(
                "DM Sans", "Inter", "system-ui", "sans-serif", "Apple Color Emoji",
                "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
            )
        }
    }
}
